import useUser from "@/api/apis";
import { GameQueryOptions } from "@/api/game-api";
import { fetchData, Method } from "@/utils/fetcher";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const ReviewResourcePath = "/sdk-api/api/v2/bhaptics-contents-review";

export function useCreateReview(slug: string) {
  const queryClient = useQueryClient();
  const { token } = useUser();
  return useMutation({
    mutationFn: async (review: Omit<BhapticsContentsReview, "id">) => {
      return await fetchData<BhapticsContentsReview>({
        url: `${ReviewResourcePath}/`,
        token: token?.token,
        method: Method.POST,
        data: review,
      });
    },
    onSuccess: (result) => {
      GameQueryOptions.invalidations.game(queryClient, slug);
      queryClient.invalidateQueries({
        queryKey: [ReviewResourcePath, result.contentId],
      });
    },
  });
}

export function useUpdateReview(slug: string) {
  const queryClient = useQueryClient();
  const { token } = useUser();
  return useMutation({
    mutationFn: async (review: BhapticsContentsReview) => {
      return await fetchData<BhapticsContentsReview>({
        url: `${ReviewResourcePath}/`,
        token: token?.token,
        method: Method.PUT,
        data: review,
      });
    },
    onSuccess: (result) => {
      GameQueryOptions.invalidations.game(queryClient, slug);
      queryClient.invalidateQueries({
        queryKey: [ReviewResourcePath, result.contentId],
      });
    },
  });
}

export function useMyReview(contentId: string) {
  const { token } = useUser();
  return useQuery({
    queryKey: [ReviewResourcePath, contentId],
    enabled: !!token,
    queryFn: () => {
      return fetchData<BhapticsContentsReview>({
        url: `${ReviewResourcePath}/my/${encodeURIComponent(contentId)}/`,
        token: token?.token,
      });
    },
  });
}
